import {BaseResponseType, DataGridRequest, PagedResponseType, WorkFlowTaskRequest} from "../shared-models/sharedTypes";
import {HttpClient} from "../../helpers";

export const WorkFlowService = {
    getAllWorkflowProcess: async (request: DataGridRequest) => {
        return await HttpClient.post<PagedResponseType<any>>(`/api/Workflow/GetAllWorkflowProcess`, request);
    }
}
